import React from 'react';
import * as PropTypes from 'prop-types';
import { TruckIcon, PromiseIcon } from 'icons/solid';
import Image from '../../atoms/Image';

const Usp = ({ className, image, altText, title, content, context }) => {
    return (
        <div
            className={`
        flex rounded-sm border 
        border-ui-gray-300 bg-ui-white p-5
        ${title ? 'flex-col items-start justify-start' : 'flex-row items-center justify-center'}
        ${className}`}
        >
            <div className='mb-2 mr-2 flex items-center gap-2'>
                {image && typeof image === 'string' ? (
                    <Image
                        layout='fixed'
                        src={image}
                        alt={altText}
                        width={title ? 24 : 43}
                        height={title ? 24 : 43}
                    />
                ) : context === 'promo' ? (
                    <TruckIcon className={title ? 'h-6 w-6' : 'h-10 w-10'} />
                ) : (
                    <PromiseIcon className={title ? 'h-6 w-6' : 'h-10 w-10'} />
                )}
                {title && (
                    <h4 className='font-semibold mb-0 font-body text-normal leading-tight'>
                        {title}
                    </h4>
                )}
            </div>
            <div
                dangerouslySetInnerHTML={{ __html: content }}
                className='font-light font-body text-small [&_p]:mb-0'
            />
        </div>
    );
};

Usp.displayName = 'Usp';

Usp.defaultProps = {};

Usp.propTypes = {
    className: PropTypes.string,
    image: PropTypes.string,
    altText: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    context: PropTypes.string,
};

export default Usp;
